import { render, staticRenderFns } from "./ThemesPage.vue?vue&type=template&id=3437074e&scoped=true&"
import script from "./ThemesPage.vue?vue&type=script&lang=ts&"
export * from "./ThemesPage.vue?vue&type=script&lang=ts&"
import style0 from "./ThemesPage.vue?vue&type=style&index=0&id=3437074e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3437074e",
  null
  
)

export default component.exports